export enum IrisBannerType {
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  DISABLED = 'disabled',
}
